/**
 * AssistantMessage — respuesta de ARIA en sus chats propios (AIPanel, Mission
 * Control): el markdown de `shared/AriaMarkdown` más la barra de fuentes con
 * departamentos, que es lo único específico de ARIA y por eso se queda aquí.
 */

import { memo } from 'react';
import AriaMarkdown from '@/components/shared/AriaMarkdown';
import SourcesBar from './SourcesBar';

function AssistantMessageBase({ content, streaming = false, sources, meta, onSourceClick }) {
  // Tier 1 — si el contenedor pasó `sources` (departamentos + tools + meta),
  // renderiza la barra verificable con deep-links y "Cómo lo sé". Si no
  // (p.ej. AIPanel), cae al chip plano derivado del texto (retrocompatible).
  const hasRichSources = Array.isArray(sources) && sources.length > 0;
  return (
    <AriaMarkdown
      content={content}
      streaming={streaming}
      footer={hasRichSources ? <SourcesBar sources={sources} meta={meta} onSourceClick={onSourceClick} /> : undefined}
    />
  );
}

const AssistantMessage = memo(
  AssistantMessageBase,
  (prev, next) =>
    prev.content === next.content &&
    prev.streaming === next.streaming &&
    prev.sources === next.sources &&
    prev.meta === next.meta &&
    prev.onSourceClick === next.onSourceClick,
);
export default AssistantMessage;
